import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { WifiOff } from "lucide-react";
import { ReactNode, useEffect, useState } from "react";

interface NoNetwork {
  children: ReactNode;
}

const NoNetwork: React.FC<NoNetwork> = ({ children }) => {
  const [isOnline, setOnline] = useState(true);

  useEffect(() => {
    setOnline(navigator.onLine);

    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) {
    return <>{children}</>;
  } else {
    return (
      <div className='min-h-screen flex items-center justify-center bg-gray-50 p-4'>
        <Card className='w-full max-w-md text-center'>
          <CardHeader>
            <div className='mx-auto flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4'>
              <WifiOff className='w-8 h-8 text-red-600' />
            </div>
            <CardTitle className='text-xl'>No Network Connection</CardTitle>
            <CardDescription>
              Please check your internet connection and try again.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button onClick={() => window.location.reload()} className='w-full'>
              Try Again
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }
};

export default NoNetwork;
